import { apiFunction } from '../functions';

/* -------------------------------------------------------------------------- */
/*                               NEW AE Based APIs                            */
/* -------------------------------------------------------------------------- */
export const registerUser = async (payload) => {
  return await apiFunction('auth/register', 'post', payload, false, null);
};

export const resendOTP = async (payload) => {
  return await apiFunction('auth/resend-otp', 'post', payload, false, null);
};

export const verifyEmail = async (payload) => {
  return await apiFunction('auth/verify-email', 'post', payload, false, null);
};

export const loginUser = async (payload) => {
  return await apiFunction('auth/login', 'post', payload, false, null);
};

export const verifyLogin = async (payload) => {
  return await apiFunction('auth/verify-login', 'post', payload, false, null);
};

// Products
export const getAllProducts = async (payload) => {
  return await apiFunction('products/list', 'get', payload, true, null);
};

export const getProductDetails = async (productId) => {
  return await apiFunction(`products/${productId}`, 'get', {}, true, null);
};

export const getProductSearch = async (query) => {
  const params = new URLSearchParams();
  Object.keys(query).forEach((key) => {
    if (query[key]) {
      params.append(key, query[key]);
    }
  });

  const queryString = params.toString();
  return await apiFunction(
    `products/list${queryString ? `?${queryString}` : ''}`,
    'get',
    {},
    true,
    null
  );
};

export const getCategories = async () => {
  return await apiFunction('categories/list', 'get', {}, true, null);
};

export const getCategoriesBySlug = async (slug) => {
  return await apiFunction(`categories/products${slug}`, 'get', {}, true, null);
};

// User Profile
export const getProfile = async () => {
  return await apiFunction('auth/profile', 'get', {}, true, null);
};

// Purchase Product
export const purchaseProduct = async (payload) => {
  return await apiFunction('orders/create', 'post', payload, true, null);
};

// User Order List
export const fetchUserOrder = async () => {
  return await apiFunction(`orders/list`, 'get', {}, true, false);
};

// Voucher Details
export const fetchVoucherDetails = async (orderId) => {
  return await apiFunction(`/orders/${orderId}/vouchers`, 'get', {}, true, false);
};

// User Statement
export const fetchUserStatement = async () => {
  return await apiFunction(`/orders/statement`, 'get', {}, true, false);
};

export const userAccountDelete = async (reason) => {
  const payload = { reason };

  return await apiFunction('/auth/delete-account', 'delete', payload, true, false);
};
/* -------------------------------------------------------------------------- */
/*                               END                                          */
/* -------------------------------------------------------------------------- */

export const getAllCategories = async () => {
  return await apiFunction('categories', 'get', {}, true, null);
};

// Login
export const getLogin = async (payload) => {
  return await apiFunction('user/login', 'post', payload, false, null);
};

// Sign up
export const signUp = async (payload) => {
  return await apiFunction('user/register', 'post', payload, false, null);
};

// Validate OTP -- otp send to user's phone
export const validateOtp = async (mobile) => {
  return await apiFunction(`user/reSendOtp/${mobile}`, 'post', {}, false, null);
};

// Validate OTP -- user's otp validate --
export const verifyUserOtp = async (payload) => {
  return await apiFunction(`user/verifyOtp`, 'post', payload, true, null);
};

// Validate OTP -- user's otp validate
export const verifyForgotUserOtp = async (payload) => {
  return await apiFunction(`user/verifyOtpForgot`, 'post', payload, false, null);
};

// Get all Blogs
export const getBlogs = async () => {
  return await apiFunction('getblogs', 'get', {}, false, null);
};

// HomePage

// Sliders Images / Hero Section Images
export const getSliderImages = async () => {
  return await apiFunction('sliders', 'get', {}, false, null);
};

// All Categories
export const getAllCategory = async () => {
  return await apiFunction('categories', 'get', {}, true, null);
};

// Top Five Products Api --
export const getTopFiveProducts = async () => {
  return await apiFunction('topfive', 'get', {}, true, null);
};

// Best Seller Products Api --
export const getBestSellers = async () => {
  return await apiFunction('bestseller', 'get', {}, true, null);
};

// Featured Products Api --
export const getFeaturedProducts = async () => {
  return await apiFunction('featured', 'get', {}, true, null);
};

// All Product List
// export const getAllProducts = async (payload) => {
//   return await apiFunction('list', 'post', payload, true, null);
// };

// Product Details
// export const getProductDetails = async (productId) => {
//   return await apiFunction(`gift/details/${productId}`, 'post', {}, true, null);
// };

//Contact us
export const sendContactUs = async (payload) => {
  return await apiFunction('send-query', 'post', payload, false, null);
};

//Contact us
export const sendCompany = async (payload) => {
  return await apiFunction('/submit-corporate', 'post', payload, false, null);
};

//UserContact us
export const userComplainQuery = async (payload) => {
  return await apiFunction('send-query', 'post', payload, false, null);
};

//subscribe us
export const sendSubscribeUs = async (payload) => {
  return await apiFunction('subscribe', 'post', payload, false, null);
};

//validate token
export const validateToken = async () => {
  return await apiFunction('user/validate-token', 'post', {}, true, null);
};

//forgot password -- password change
export const forgotUserPassword = async (payload) => {
  return await apiFunction('user/forgot-password', 'post', payload, true, null);
};

//Balance
export const userBalance = async () => {
  return await apiFunction('user/balance', 'post', {}, true, null);
};

// Purchase Products
// export const purchaseProduct = async (payload) => {
//   return await apiFunction('user/gift/purchase', 'put', payload, true, null);
// };

// Dashboard Pages API CALLS
// export const fetchUserOrders = async (payload) => {
//   return await apiFunction(`user/reports/0`, 'post', payload, true, false);
// };

// find Voucher Details
export const fetchVoucherDetail = async (orderId, payload) => {
  return await apiFunction(`/user/card-list-new/${orderId}`, 'post', payload, true, false);
};

// find Voucher Details
export const razorpayVerifyPayment = async (orderId, payload) => {
  return await apiFunction(`/user/gift/verify-payment`, 'put', payload, true, false);
};

// find Voucher Details
// export const userAccountDelete = async (payload) => {
//     return await apiFunction(`/user/deleteprofile`, 'post', payload, true, false);
// };

// fetch Notifications
export const fetchAllNotifications = async (payload) => {
  return await apiFunction(`user/notifications`, 'post', payload, true, false);
};

// all Sections
export const fetchMobileHomepage = async () => {
  return await apiFunction(`all-sections`, 'post', {}, true, false);
};

// upload user custom image
export const uploadWishPostImage = async (formData) => {
  return await apiFunction(`user/add-url-templete`, 'post', formData, true, 'multipart');
};
